import { type IconSize } from '@air/design-icons';
import { tailwindVariants, type VariantProps } from '@air/utils-tailwind';

export const fileStatusIcon = tailwindVariants({
  defaultVariants: {
    size: 'default',
  },
  slots: {
    container: 'mr-3 flex items-center justify-center',
    spinner: '',
  },
  variants: {
    size: {
      compact: {
        container: 'size-6 shrink-0',
        spinner: 'size-4',
      },
      default: {
        container: 'size-10',
        spinner: 'size-6',
      },
    },
  },
});

export type FileStatusIconSize = NonNullable<VariantProps<typeof fileStatusIcon>['size']>;

export const FILE_STATUS_ICON_GLYPH_SIZE = {
  compact: 'sm',
  default: 'lg',
} satisfies Record<FileStatusIconSize, IconSize>;

export const getFileStatusIconGlyphSize = (size: FileStatusIconSize): IconSize => FILE_STATUS_ICON_GLYPH_SIZE[size];
